import React from 'react';
import Header from '../components/header/HeaderOne';
import FooterTwo from '../components/footer/FooterTwo';

import HeroTwo from '../components/sections/HeroTwo';
import FeatureSecOne from '../components/sections/FeatureSecOne';
import AboutSecTwo from '../components/sections/AboutSecTwo';
import ServiceSecTwo from '../components/sections/ServiceSecTwo';
import BrandOne from '../components/sections/BrandOne';
import ProcessSecOne from '../components/sections/ProcessSecOne';
import TeamSecTwo from '../components/sections/TeamSecTwo';
import NetworkSecOne from '../components/sections/NetworkSecOne';
import WhySecTwo from '../components/sections/WhySecTwo';
import CtaSecOne from '../components/sections/CtaSecOne';
import TestiSecTwo from '../components/sections/TestiSecTwo';
import BlogSecTwo from '../components/sections/BlogSecTwo';

const HomeTwo = () => {
  return (
    <>
      <Header />
      <div className="home-two">
        <HeroTwo />
        <FeatureSecOne className=" position-relative z-index-common" />
        <AboutSecTwo className=" position-relative overflow-hidden space" />
        <ServiceSecTwo className=" bg-smoke space overflow-hidden" />
        <BrandOne className="space" />
        <ProcessSecOne className="space-bottom overflow-hidden" />
        <TeamSecTwo className="bg-smoke space overflow-hidden" /> 
        
        <NetworkSecOne className="space-bottom overflow-hidden" />
        <WhySecTwo className="space-bottom overflow-hidden" />
        <CtaSecOne className="space bg-smoke overflow-hidden" />
        <TestiSecTwo className="space overflow-hidden" />
        <BlogSecTwo className="space bg-smoke overflow-hidden" />
      </div>
      <FooterTwo />
    </>
  );
};

export default HomeTwo;
